"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1611],{

/***/ 59533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Properties; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72462);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88078);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(32542);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15054);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55791);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23077);
/* harmony import */ var _ui_headers_NoticeHeader__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38070);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33030);
/* harmony import */ var _partials_Filters__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7828);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28695);
/* harmony import */ var _property_content_columned_right_SwipeableDrawerFilters__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81451);
/* harmony import */ var _helpers_class_Calendar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(19601);
/* harmony import */ var _partials_SwipperWrapper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82411);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30719);














var List = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4445), __webpack_require__.e(8000)]).then(__webpack_require__.bind(__webpack_require__, 28276));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28276)
            ];
        }
    },
    suspense: true
});
var Thumbs = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4445), __webpack_require__.e(3361), __webpack_require__.e(9094)]).then(__webpack_require__.bind(__webpack_require__, 63361));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63361)
            ];
        }
    },
    suspense: true
});
var BookingSearchBar = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 83074));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83074)
            ];
        }
    },
    suspense: true
});
var GoogleMapContent = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(8430), __webpack_require__.e(4445), __webpack_require__.e(9567), __webpack_require__.e(4779)]).then(__webpack_require__.bind(__webpack_require__, 29567));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29567)
            ];
        }
    },
    suspense: true
});
var FlexibleSearchBar = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 89316));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89316)
            ];
        }
    },
    suspense: true
});




function Properties(props) {
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useT */ .NT)();
    var isRelatedSection = props.hasOwnProperty("isRelatedSection") ? props.isRelatedSection : false;
    var updateUri = props.hasOwnProperty("updateUri") ? props.updateUri : true;
    var isMobile = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    _helpers_class_Calendar__WEBPACK_IMPORTED_MODULE_16__/* ["default"].setProps */ .Z.setProps(props);
    var calendarMaterialTheme = _helpers_class_Calendar__WEBPACK_IMPORTED_MODULE_16__/* ["default"].getCalendarMaterialTheme */ .Z.getCalendarMaterialTheme;
    var calendar = {
        customTheme: calendarMaterialTheme
    };
    var isListingPage = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["isListingPage"];
    });
    var showBookingBar = props.hasOwnProperty("showBookingBar") ? props.showBookingBar : true;
    var searchBarInDrawer = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_search_in_drawer"));
    });
    var propertiesIndex = props.hasOwnProperty("propertiesIndex") ? props.propertiesIndex : false;
    var showTotalPropertiesCount = props.hasOwnProperty("showTotalPropertiesCount") ? props.showTotalPropertiesCount : true;
    var thumbClassInherited = props.hasOwnProperty("thumbClassInherited") ? props.thumbClassInherited : false;
    var showFiltersBar = props.hasOwnProperty("showFiltersBar") ? props.showFiltersBar : true;
    var useSwipper = props.hasOwnProperty("useSwipper") ? props.useSwipper : false;
    var slidesPerViewDesktop = props.hasOwnProperty("slidesPerViewDesktop") ? props.slidesPerViewDesktop : 2.5;
    var propertiesContainerExtraClass = props.hasOwnProperty("propertiesContainerExtraClass") ? props.propertiesContainerExtraClass : "px-2";
    var hasDestination = props.hasOwnProperty("destinationId") ? true : false;
    var searchBarSentinelRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var propertiesData = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesData"];
    });
    var checkin = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkin"];
    });
    var checkout = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["checkout"];
    });
    var pageId = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["page_id"];
    });
    var pageLimit = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["limit"];
    });
    var adults = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["adults"];
    });
    var kids = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["kids"] + state["propertiesParams"]["infants"];
    });
    var fetchWebhotelierPrices = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_webhotelier_prices"));
    });
    var fetchWebhotelierMemberPrices = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean((0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_webhotelier_prices_members"));
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchPropertiesPricesAction */ .ZM)(propertiesData, pageId, checkin, checkout, adults, kids, fetchWebhotelierPrices, undefined, fetchWebhotelierMemberPrices));
    }, [
        propertiesData,
        fetchWebhotelierPrices
    ]);
    var propertiesParams = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"];
    });
    var propertiesOffset = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["offset"];
    });
    var loadingProperties = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["loadingProperties"];
    });
    var paramsApplied = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["paramsApplied"];
    });
    var uiSearchBarDivHeight = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["uiData"]["searchBarDivHeight"];
    });
    var unavailabelPropertiesViewType = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_properties_unavailable_view_type");
    });
    var getPaginationNumber = function(count) {
        return Math.ceil(count / pageLimit);
    };
    var paginationCounter = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return getPaginationNumber(state["propertiesData"]["count"]);
    });
    var properties = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesData"]["properties"];
    });
    var propertiesCounter = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesData"]["properties_count"];
    });
    // useEffect(() => {
    //   console.log("forDebug", "paginationCounter", paginationCounter)
    //   console.log("forDebug", "paginationCounter", props.properties_count > 24)
    //   console.log("forDebug", "paginationCounter",  Checkers.isValidArray(properties))
    //   console.log("forDebug", "paginationCounter",  propertiesCounter)
    // }, [paginationCounter]);
    var pageNumber = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["propertiesParams"]["pageNumber"];
    });
    var offsetHandler = function() {
        var page_number = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pageNumber;
        var offset = (page_number - 1) * pageLimit;
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setOffset */ .nb)(offset));
        return offset;
    };
    var app = props.app;
    var builder = props.builder;
    var centerObj = {};
    var property_id = 0;
    var skeletonProperties = [];
    var enableMapClustering = app.builder.builder_propertylist_map_enable_cluster;
    var randomizePin = app.builder.builder_propertylist_map_enable_randomize_pin;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
    // console.log("randomizePin", randomizePin)
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mouseMapClick = ref[0], setMouseMapClick = ref[1];
    var mapEnabled = props.googleMapShow && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_map);
    var propertiesMapEnabled = mapEnabled ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_propertylist_enable_map) : false;
    var mapInit = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].googleMapsPropertyInit */ .Z.googleMapsPropertyInit(props.googleMapApiKey, propertiesMapEnabled, 0, 0);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(mapInit), showMap = ref1[0], setShowMap = ref1[1];
    // useEffect( () => {
    //   console.log("propertiesMapEnabled", mapEnabled, propertiesMapEnabled, builder.builder_propertylist_enable_map)
    // })
    var galleryRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(285), galleryHeight = ref2[0], setGalleryHeight = ref2[1];
    var propertiesViewType = builder.builder_properties_view_type.toString();
    var viewTypeClass = propertiesViewType == "207" ? "Properties-List" : "Properties-Thumb";
    var ratio = 13;
    if (propertiesViewType == "207") {
        ratio = 11;
    } else {
        ratio = showMap ? 13 : 11;
    }
    var listClass = showMap ? "col-12 mb-3" : "col-12 col-sm-12 col-md-10 col-lg-10 mb-3";
    var thumbClass = showMap ? "col-12 col-sm-6 col-md-6 mb-3" : "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3";
    if (thumbClassInherited !== false) {
        thumbClass = thumbClassInherited;
    } else {
        if (!showMap && propertiesViewType == "206") {
            switch(builder.builder_properties_columns){
                case 2:
                case "2":
                    thumbClass = "col-12 col-sm-6 col-md-6 mb-3";
                    break;
                case 3:
                case "3":
                    thumbClass = "col-12 col-sm-6 col-md-6 col-lg-4 mb-3";
                    ratio = 13;
                    break;
                case 4:
                case "4":
                default:
                    thumbClass = "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3";
                    ratio = 15;
                    break;
            }
        }
    }
    for(var i = 0; i < pageLimit; i++){
        skeletonProperties.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: propertiesViewType == "207" ? listClass : thumbClass,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Skeleton Properties ".concat(viewTypeClass, " Properties-Border Properties-Shadow row w-100 m-0"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "".concat(propertiesViewType == "207" ? "col-12 col-sm-6 col-md-5" : "col-12", " p-0"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            variant: "rectangular",
                            width: "100%",
                            className: "b-rad-md",
                            style: {
                                height: galleryHeight
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "Properties__body ".concat(propertiesViewType == "207" ? "col-12 col-sm-6 col-md-7" : "col-12", " px-3 py-2"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                variant: "text",
                                width: 92,
                                height: 18
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                variant: "text",
                                width: 132,
                                height: 25
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                variant: "text",
                                width: 250,
                                height: 35
                            })
                        ]
                    })
                ]
            })
        }, i.toString()));
    }
    /**
   * -> PROPERTIES GOOGLE MAP
   **/ properties.forEach(function(property) {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidNumber */ .Z.isValidNumber(property.lat) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidNumber */ .Z.isValidNumber(property.lng)) {
            centerObj = {
                lat: parseFloat(property.lat),
                lng: parseFloat(property.lng)
            };
            property_id = property.property_id;
            return;
        }
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(centerObj), relocatedCenter = ref3[0], setRelocatedCenter = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(property_id), previousProperty = ref4[0], setPreviousProperty = ref4[1];
    var changeMarkerOnClick = function(lat, lng, property_id) {
        changeMarker(lat, lng, property_id);
    };
    var changeMarkerOnHover = function(lat, lng, property_id) {
        if (infoWindowState == null) {
            changeMarker(lat, lng, property_id);
        }
    };
    var changeMarker = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(lat, lng, property_id) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        centerObj = {};
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidNumber */ .Z.isValidNumber(lat) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidNumber */ .Z.isValidNumber(lng)) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            centerObj = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };
        }
        var thisChild = document.getElementById("property_marker_" + property_id);
        var prevChild = document.getElementById("property_marker_" + previousProperty);
        if (thisChild) {
            thisChild.parentElement.style.zIndex = "1";
        }
        if (prevChild) {
            prevChild.parentElement.style.zIndex = "0";
        }
        setRelocatedCenter(function() {
            return centerObj;
        });
        setPreviousProperty(property_id);
    }, [
        relocatedCenter,
        previousProperty
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), pixelOffsetX = ref5[0], setPixelOffsetX = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), pixelOffsetY = ref6[0], setPixelOffsetY = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), secondState = ref7[0], setSecondState = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), infoWindowState = ref8[0], setInfoWindowState = ref8[1];
    var openInfoWindow = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(clientWidth, clientHeight) {
        setPixelOffsetX(function() {
            return clientWidth;
        });
        setPixelOffsetY(function() {
            return clientHeight;
        });
        setSecondState(true);
    }, []);
    var updateInfoWindowState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(state) {
        setSecondState(false);
        setMouseMapClick(true);
        setInfoWindowState(function() {
            return state;
        });
    }, []);
    /**
   * -> PROPERTIES GOOGLE MAP END
   **/ var mapRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var searchBarRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var filtersDivRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var propertiesRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), searchBarDivHeight = ref9[0], setSearchBarDivHeight = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), actualSearchBarHeight = ref10[0], setActualSearchBarHeight = ref10[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var el = document.getElementById("search_bar");
        if (!el) return;
        var ro = new ResizeObserver(function() {
            return setActualSearchBarHeight(el.offsetHeight);
        });
        ro.observe(el);
        setActualSearchBarHeight(el.offsetHeight);
        return function() {
            return ro.disconnect();
        };
    }, []);
    var updateSearchDivHeight = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(searchBarDiv, bodyWidth) {
        if (showBookingBar) {
            if (bodyWidth > 768 && searchBarDiv != undefined) {
                if (searchBarDiv != undefined && searchBarDiv.hasOwnProperty("searchBarDiv")) {
                    setSearchBarDivHeight(function() {
                        return searchBarDiv.clientHeight;
                    });
                    dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setUiSearchBarDivHeight */ .PL)(searchBarDiv.clientHeight));
                }
            } else {
                setSearchBarDivHeight(function() {
                    return 0;
                });
            }
        } else {
            setSearchBarDivHeight(function() {
                return 0;
            });
        }
    }, []);
    var builderMapWidth = 100 - (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_propertylist_map_width");
    });
    var setDivWidthHeightTop = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(filtersDiv, propertiesDiv, mapDiv, searchBarDiv, bodyHeight, bodyWidth) {
        if (mapDiv) {
            // SET MAP HEIGHT / WIDTH AND STICKY TOP POSITION
            var filtersTop = app.bookingSearchbarWidth === null ? !isDesktop ? 0 : 93 : searchBarDivHeight;
            var mapTop = filtersDiv ? filtersTop + filtersDiv.offsetHeight : filtersTop;
            mapDiv.style.top = mapTop + "px";
            mapDiv.style.height = bodyHeight - mapTop + "px";
            mapDiv.style.width = bodyWidth - propertiesDiv.clientWidth - 1 + "px";
            // TOGGLE PROPERTIES DIV WIDTH
            if (propertiesDiv) {
                if (bodyWidth <= 991) {
                    propertiesDiv.style.maxWidth = "initial";
                    setShowMap(false);
                } else if (bodyWidth > 991 && mapInit) {
                    if (!useSwipper) {
                        propertiesDiv.style.maxWidth = builderMapWidth + "%";
                    }
                }
            }
        }
    }, [
        mapInit,
        searchBarDivHeight,
        app.bookingSearchbarWidth,
        isDesktop
    ]);
    var fetchProperties = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : propertiesParams, page_number = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pageNumber, offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : propertiesOffset;
        var asPath = router.asPath.split("/page")[0];
        if (updateUri) {
            if (page_number > 1) window.history.pushState("", "", (asPath == "/" ? "" : asPath) + "/page/".concat(page_number));
            else window.history.pushState("", "", asPath);
        }
        params.offset = offset;
        params.limit = pageLimit;
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchPropertiesAction */ .SH)(params, null, uiSearchBarDivHeight));
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setApplyParams */ .DY)(0));
        setMouseMapClick(false);
    }, [
        propertiesOffset,
        router.asPath
    ]);
    var pageNumberHandler = function(page) {
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .setPageNumber */ .oW)(parseInt(page)));
        var offset = offsetHandler(page);
        fetchProperties(propertiesParams, page, offset);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var mapDiv;
        var filtersDiv;
        var searchBarDiv;
        var propertiesDiv;
        var galleryDiv;
        if (showBookingBar && document !== undefined && window !== undefined) {
            var body = document.querySelector("body").getBoundingClientRect();
            if (body) {
                mapDiv = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current;
                filtersDiv = filtersDivRef === null || filtersDivRef === void 0 ? void 0 : filtersDivRef.current;
                searchBarDiv = searchBarRef === null || searchBarRef === void 0 ? void 0 : searchBarRef.current;
                propertiesDiv = propertiesRef === null || propertiesRef === void 0 ? void 0 : propertiesRef.current;
                galleryDiv = galleryRef === null || galleryRef === void 0 ? void 0 : galleryRef.current;
                if (galleryDiv) setGalleryHeight(galleryDiv.clientWidth * ratio / 16);
                updateSearchDivHeight(searchBarDiv, body.width);
                setDivWidthHeightTop(filtersDiv, propertiesDiv, mapDiv, searchBarDiv, body.height, body.width);
                if (body.width > 768 && searchBarDiv != undefined) {
                    setSearchBarDivHeight(function() {
                        return searchBarDiv.clientHeight;
                    });
                } else {
                    setSearchBarDivHeight(function() {
                        return 0;
                    });
                }
                window.addEventListener("resize", function() {
                    if (this.innerWidth > 991 && mapInit) {
                        setShowMap(true);
                    }
                    if (galleryDiv) setGalleryHeight(galleryDiv.clientWidth * ratio / 16);
                    updateSearchDivHeight(searchBarDiv, this.innerWidth);
                    setDivWidthHeightTop(filtersDiv, propertiesDiv, mapDiv, searchBarDiv, this.innerHeight, this.innerWidth);
                });
                // SET SHADOW ONLY ON SCROLL, OIN FILTERS DIV
                window.addEventListener("scroll", function() {
                    if (filtersDiv && searchBarDiv) {
                        if (searchBarDiv.getBoundingClientRect().top == 0 || filtersDiv.getBoundingClientRect().top == 0) {
                            filtersDiv.style.boxShadow = "0 8px 6px -6px #ccc";
                            filtersDiv.style.webkitBoxShadow = "0 8px 6px -6px #ccc";
                        } else {
                            filtersDiv.style.boxShadow = "none";
                            filtersDiv.style.webkitBoxShadow = "none";
                        }
                        if (searchBarDivHeight === 0) {
                            updateSearchDivHeight(searchBarDiv, this.innerWidth);
                        }
                    }
                });
            }
        }
    }, [
        mapInit,
        ratio,
        router,
        searchBarDivHeight,
        setDivWidthHeightTop,
        updateSearchDivHeight,
        builderMapWidth
    ]);
    var borderRadiusForBorder = builder.builder_properties_radius - 2;
    var containerClass = showMap ? "container-fluid p-0" : "container p-0";
    var filtersDivClass = "Properties-Index__properties-filters bg-master-lightest ".concat(app.bookingSearchbarWidth === null ? "" : "sticky-top", "  ").concat(isDesktop ? "py-3" : "py-2", " px-2 mb-3 w-100 m-0");
    var searchbarClassNoFlex = "bg-white border-top border-bottom sticky-md-top w-100 Properties-Index__searchbar";
    var searchbarClassFlex = "w-100 Properties-Index__searchbar";
    var textColor = "text-black";
    var borderColor = "b-transparent-black";
    var buttonColor = "b-transparent-black";
    if (props.searchbarThemeColor != null && !props.searchbarThemeColor) {
        textColor = "text-white";
        borderColor = "b-transparent-white";
        buttonColor = "b-transparent-white";
    }
    var renderProperty = function(property, key) {
        var useSkeleton = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var availabilityStatus = property.availabilityStatus != undefined ? property.availabilityStatus : null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: useSkeleton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidDate */ .Z.isValidDate(checkin) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidDate */ .Z.isValidDate(checkout) && property.availabilityStatus != null && (properties[key - 1] && properties[key - 1]["availabilityStatus"] == 1 && property.availabilityStatus != 1 || !properties[key - 1] && property.availabilityStatus != 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_headers_NoticeHeader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            title: t("properties.notAvailableRange")
                        })
                    }) : "",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        parentClassName: propertiesViewType == "207" ? listClass : thumbClass,
                        skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "Skeleton Properties ".concat(viewTypeClass, " Properties-Border Properties-Shadow row w-100 m-0"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat(propertiesViewType == "207" ? "col-12 col-sm-6 col-md-5" : "col-12", " p-0"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                        variant: "rectangular",
                                        width: "100%",
                                        className: "b-rad-md",
                                        style: {
                                            height: galleryHeight
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "Properties__body ".concat(propertiesViewType == "207" ? "col-12 col-sm-6 col-md-7" : "col-12", " px-3 py-2"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            variant: "text",
                                            width: 92,
                                            height: 18
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            variant: "text",
                                            width: 132,
                                            height: 25
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            variant: "text",
                                            width: 250,
                                            height: 35
                                        })
                                    ]
                                })
                            ]
                        }),
                        children: isRelatedSection || (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .getPropertyViewType */ .n9)(availabilityStatus, propertiesViewType, unavailabelPropertiesViewType) == "206" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Thumbs, {
                                property_id: property.property_id,
                                property_title: property.property_title,
                                property_moto: property.moto,
                                property_location: property.location,
                                property_lat: property.lat,
                                property_lng: property.lng,
                                availabilityStatus: availabilityStatus,
                                minmimStayData: property.minmimStayData,
                                images: property.featured_images,
                                captions: property.captions,
                                thumbClass: thumbClass,
                                changeMarkerOnHover: changeMarkerOnHover,
                                galleryHeight: galleryHeight,
                                galleryRef: galleryRef,
                                sourcePath: property.sourcePath,
                                minimumPrice: property.hasOwnProperty("range_price") && property.range_price != null ? property.range_price : property.minimum_price,
                                capacity: property.capacity,
                                complexCount: property.complexCount,
                                bedrooms: property.bedrooms,
                                tags: property.tags,
                                system_type_id: property.system_type_id,
                                classification: property.classification,
                                propertyType: property.type,
                                isHotel: props.isHotel,
                                isChain: props.isChain,
                                hidePrices: props.hidePrices
                            }, property.property_id.toString())
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                                property_id: property.property_id,
                                property_title: property.property_title,
                                property_moto: property.moto,
                                property_location: property.location,
                                property_lat: property.lat,
                                property_lng: property.lng,
                                availabilityStatus: availabilityStatus,
                                minmimStayData: property.minmimStayData,
                                images: property.featured_images,
                                listClass: listClass,
                                changeMarkerOnHover: changeMarkerOnHover,
                                galleryHeight: galleryHeight,
                                sourcePath: property.sourcePath,
                                capacity: property.capacity,
                                complexCount: property.complexCount,
                                bedrooms: property.bedrooms,
                                minimumPrice: property.hasOwnProperty("range_price") && property.range_price != null ? property.range_price : property.minimum_price,
                                galleryRef: galleryRef,
                                system_type_id: property.system_type_id,
                                classification: property.classification,
                                propertyType: property.type
                            }, property.property_id.toString())
                        })
                    }, key)
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidDate */ .Z.isValidDate(checkin) && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidDate */ .Z.isValidDate(checkout) && property.availabilityStatus != null && (properties[key - 1] && properties[key - 1]["availabilityStatus"] == 1 && property.availabilityStatus != 1 || !properties[key - 1] && property.availabilityStatus != 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_headers_NoticeHeader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        title: t("properties.notAvailableRange")
                    }) : "",
                    isRelatedSection || (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .getPropertyViewType */ .n9)(availabilityStatus, propertiesViewType, unavailabelPropertiesViewType) == "206" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Thumbs, {
                            property_id: property.property_id,
                            property_title: property.property_title,
                            property_moto: property.moto,
                            property_location: property.location,
                            property_lat: property.lat,
                            property_lng: property.lng,
                            availabilityStatus: availabilityStatus,
                            minmimStayData: property.minmimStayData,
                            images: property.featured_images,
                            captions: property.captions,
                            thumbClass: thumbClass,
                            changeMarkerOnHover: changeMarkerOnHover,
                            galleryHeight: galleryHeight,
                            galleryRef: galleryRef,
                            sourcePath: property.sourcePath,
                            minimumPrice: property.hasOwnProperty("range_price") && property.range_price != null ? property.range_price : property.minimum_price,
                            capacity: property.capacity,
                            bedrooms: property.bedrooms,
                            tags: property.tags,
                            system_type_id: property.system_type_id,
                            classification: property.classification,
                            propertyType: property.type,
                            isHotel: props.isHotel,
                            isChain: props.isChain,
                            hidePrices: props.hidePrices
                        }, property.property_id.toString())
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(List, {
                            property_id: property.property_id,
                            property_title: property.property_title,
                            property_moto: property.moto,
                            property_location: property.location,
                            property_lat: property.lat,
                            property_lng: property.lng,
                            availabilityStatus: availabilityStatus,
                            minmimStayData: property.minmimStayData,
                            images: property.featured_images,
                            listClass: listClass,
                            changeMarkerOnHover: changeMarkerOnHover,
                            galleryHeight: galleryHeight,
                            sourcePath: property.sourcePath,
                            capacity: property.capacity,
                            bedrooms: property.bedrooms,
                            minimumPrice: property.hasOwnProperty("range_price") && property.range_price != null ? property.range_price : property.minimum_price,
                            galleryRef: galleryRef,
                            system_type_id: property.system_type_id,
                            classification: property.classification,
                            propertyType: property.type
                        }, property.property_id.toString())
                    })
                ]
            })
        });
    };
    var propertiesComponent = [];
    properties.map(function(property, index) {
        propertiesComponent.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_15__/* .SwiperSlide */ .o5, {
            children: renderProperty(property, index, false)
        }, "related-property-" + property.property_id));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(builder.builder_properties_radius) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "3a00dd55da491a40",
                dynamic: [
                    builder.builder_properties_radius,
                    builder.builder_properties_radius,
                    builder.builder_properties_radius,
                    app.builder.builder_properties_radius / 0.5 * 2,
                    app.builder.builder_properties_radius / 0.5 * 2,
                    app.builder.builder_properties_radius / 0.5 * 2
                ],
                children: ".Properties,.Properties .Properties__gallery,.Properties .Properties__gallery>div{border-radius:".concat(builder.builder_properties_radius, "px;-moz-border-radius:").concat(builder.builder_properties_radius, "px;-webkit-border-radius:").concat(builder.builder_properties_radius, "px}.Properties .Properties__gallery .swiper-custom-prev,.Properties .Properties__gallery .swiper-custom-next{border-radius:").concat(app.builder.builder_properties_radius / 0.5 * 2, "%!important;-moz-border-radius:").concat(app.builder.builder_properties_radius / 0.5 * 2, "%!important;-webkit-border-radius:").concat(app.builder.builder_properties_radius / 0.5 * 2, "%!important}")
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "a7c9d7649c4802f2",
                children: ".Properties.Properties-Shadow{box-shadow:0 6px 20px rgba(0,0,0,.2);-moz-box-shadow:0 6px 20px rgba(0,0,0,.2);-webkit-box-shadow:0 6px 20px rgba(0,0,0,.2)}.Properties.Properties-Swiper-Shadow{box-shadow:0 6px 10px rgba(0,0,0,.2);-moz-box-shadow:0 6px 20px rgba(0,0,0,.2);-webkit-box-shadow:0 6px 6px rgba(0,0,0,.2)}"
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "807bf1ffef126cd1",
                children: ".Properties.Properties-Border{border:1px solid#dee2e6}"
            }),
            (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow)) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "6f9e2c7480f116a",
                dynamic: [
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius,
                    0,
                    0,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius
                ],
                children: ".Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery,.Properties.Properties-Thumb.Properties-Border.Properties-Shadow .Properties__gallery>div{-moz-border-radius-bottomleft:0!important;border-bottom-left-radius:0!important;-moz-border-radius-bottomright:0!important;border-bottom-right-radius:0!important;-moz-border-bottom-left-radius:0!important;-moz-border-bottom-right-radius:0!important;-webkit-border-bottom-left-radius:0!important;-webkit-border-bottom-right-radius:0!important}.Properties.Properties-List.Properties-Border.Properties-Shadow .Properties__gallery,.Properties.Properties-List.Properties-Border.Properties-Shadow .Properties__gallery>div{-moz-border-radius-topright:0!important;border-top-right-radius:0!important;-moz-border-radius-bottomright:0!important;border-bottom-right-radius:0!important;-moz-border-top-right-radius:0!important;-moz-border-bottom-right-radius:0!important;-webkit-border-top-right-radius:0!important;-webkit-border-bottom-right-radius:0!important}.Properties.Properties-Thumb .Properties__body{-moz-border-radius-bottomleft:".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-radius-bottomright:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important}.Properties.Properties-List .Properties__body{-moz-border-radius-topright:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-radius-bottomright:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-bottom-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important}@media only screen and (max-width:575px){.Properties.Properties-List.Properties-Border.Properties-Shadow .Properties__gallery,.Properties.Properties-List.Properties-Border.Properties-Shadow .Properties__gallery>div{-moz-border-radius-bottomleft:", 0, "px!important;border-bottom-left-radius:", 0, "px!important;-moz-border-radius-bottomright:", 0, "px!important;border-bottom-right-radius:", 0, "px!important;-moz-border-radius-topleft:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-top-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-radius-topright:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-bottom-left-radius:", 0, "px!important;-moz-border-bottom-right-radius:", 0, "px!important;-moz-border-top-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-bottom-left-radius:", 0, "px!important;-webkit-border-bottom-right-radius:", 0, "px!important;-webkit-border-top-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-top-right-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important}.Properties.Properties-List .Properties__body{-moz-border-radius-topleft:", 0, "px!important;border-top-left-radius:", 0, "px!important;-moz-border-radius-topright:", 0, "px!important;border-top-right-radius:", 0, "px!important;-moz-border-radius-bottomleft:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-moz-border-top-left-radius:", 0, "px!important;-moz-border-top-right-radius:", 0, "px!important;-moz-border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important;-webkit-border-top-left-radius:", 0, "px!important;-webkit-border-top-right-radius:", 0, "px!important;-webkit-border-bottom-left-radius:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) ? borderRadiusForBorder : builder.builder_properties_radius, "px!important}}")
            }),
            _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidString */ .Z.isValidString(builder.builder_properties_bg_color) && (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "562b05e3a7a5387c",
                dynamic: [
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff",
                    builder.builder_properties_bg_color,
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff",
                    !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? builder.builder_properties_bg_color : "#fff",
                    !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff" : "initial",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.1)",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.2)",
                    _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? "1rem" : "1rem 0.575rem"
                ],
                children: ".Properties-Index__properties .Properties-Index__properties-filters-button{border:1px solid ".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff", ";color:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff", "!important}.Properties-Index__properties h1,.Properties-Index__properties h2,.Properties-Index__properties h3,.Properties-Index__properties h4,.Properties-Index__properties h4,.Properties-Index__properties h6,.Properties-Index__properties p,.Properties-Index__properties label{color:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff", "}.Destination-Section-Desc,.Properties-Index__searchbar,.Properties-Index__properties,.Properties-Index__properties .Properties-Index__properties-filters,.Properties-Index__searchbar .Properties-Index__searchbar-row,.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row,.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row .SearchBar-Form__column .SearchBar-Form__form-group{background-color:").concat(builder.builder_properties_bg_color, '!important}.Properties-Index__properties .Properties-Index__properties-filters,.Destination-Section-Desc .Destination-Section-Desc__row .Destination-Section-Desc__column *,.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row .SearchBar-Form__column .SearchBar-Form__form-group p,.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row .SearchBar-Form__column .SearchBar-Form__form-group label,.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row .SearchBar-Form__column .SearchBar-Form__form-group div[id$="placeholder"],.Properties-Index__searchbar .Properties-Index__searchbar-row .SearchBar-Form .SearchBar-Form__row .SearchBar-Form__column .SearchBar-Form__form-group>div:not(.SearchBar-Form__form-group-select) *{color:').concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff", "!important}.Destination-Section-Desc .Destination-Section-Desc__row .Destination-Section-Desc__column button.btn-link.text-link{text-decoration:underline}.Properties__body{background-color:").concat(!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? builder.builder_properties_bg_color : "#fff", "}.Properties.Properties-List .Properties__body{height:100%}.Properties .Properties__body>*,.Properties .Properties__body div>*{color:").concat(!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) && !_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff" : "initial", "!important}.Properties-Index__Paging ul>li>div,.Properties-Index__Paging ul>li>button{color:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "#000" : "#fff", "!important}.Properties-Index__Paging ul>li>button:hover{background-color:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.1)", "!important}.Properties-Index__Paging ul>li>button.Mui-selected{background-color:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_text_color) ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.2)", "!important}.Properties__body{padding:").concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_border) || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].valueToBoolean */ .Z.valueToBoolean(builder.builder_properties_shadow) ? "1rem" : "1rem 0.575rem", "!important}.Properties-Index__properties-filters{border-top:1px solid#dee2e6}.Properties-Index__searchbar{border:none!important}")
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "28ef697cbe5953a0",
                children: ".Skeleton.Properties .Properties__body{height:auto}"
            }),
            showBookingBar && (isDesktop || !searchBarInDrawer) && app.enableBooking && app.bookingSearchbarWidth != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    ref: searchBarRef,
                    id: "search_bar",
                    className: searchbarClassNoFlex,
                    style: {
                        zIndex: "1022"
                    },
                    children: showBookingBar && (isDesktop || !searchBarInDrawer) && app.enableBooking ? !app.bookingSearchbarWidth && (app.bookingSearchbarPosition || propertiesIndex || hasDestination) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "Properties-Index__searchbar-row row w-100 m-0 p-0 justify-content-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-lg-8 p-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookingSearchBar, {
                                containerClass: containerClass,
                                padding: 10,
                                isManager: true,
                                noShadow: true,
                                sliderSearchBar: true,
                                sliderSearchBarFullWidth: true,
                                designMode: props.designMode,
                                searchbarThemeColor: app.searchbarThemeColor,
                                rgbaDesignColor: props.rgbaDesignColor,
                                searchbarRadius: props.searchbarRadius,
                                searchbarShadow: props.searchbarShadow,
                                bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                                isHomePage: false,
                                updateUri: updateUri
                            })
                        })
                    }) : app.bookingSearchbarWidth ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "Properties-Index__searchbar-row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookingSearchBar, {
                            isDesktop: isDesktop,
                            isManager: true,
                            fullWidthBar: true,
                            designMode: app.designMode,
                            bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                            searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                            searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                            position: app.bookingSearchbarPosition,
                            isHomePage: false,
                            updateUri: updateUri
                        }, "BookingSearchBar")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: searchBarSentinelRef,
                            style: {
                                height: "1px",
                                marginTop: "-1px"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                            ref: searchBarRef,
                            id: "search_bar",
                            className: searchbarClassFlex,
                            style: {
                                zIndex: "1022"
                            },
                            children: showBookingBar && isDesktop && app.enableBooking ? app.bookingSearchbarWidth === null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "Properties-Index__searchbar-row row w-100 m-0 p-0 justify-content-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12 p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookingSearchBar, {
                                        isManager: true,
                                        sliderSearchBar: true,
                                        designMode: app.designMode,
                                        searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                                        searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                                        searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null,
                                        searchbarShadow: app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null,
                                        bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                                        isHomePage: false,
                                        isFlexible: true,
                                        updateUri: updateUri,
                                        builderRadius: builder.builder_properties_radius || 8,
                                        homepageLayout: true
                                    })
                                })
                            }) : app.bookingSearchbarWidth === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "Properties-Index__searchbar-row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookingSearchBar, {
                                    isDesktop: isDesktop,
                                    isManager: true,
                                    fullWidthBar: true,
                                    designMode: app.designMode,
                                    bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                                    searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                                    searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                                    position: app.bookingSearchbarPosition,
                                    isHomePage: false,
                                    updateUri: updateUri
                                }, "BookingSearchBar")
                            }) : app.bookingSearchbarWidth === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "Properties-Index__searchbar-row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookingSearchBar, {
                                    isDesktop: isDesktop,
                                    isManager: true,
                                    underSliderContained: true,
                                    isFlexible: true,
                                    designMode: app.designMode,
                                    bookingSearchbarWithBedrooms: app.hasOwnProperty("bookingSearchbarWithBedrooms") ? !!app.bookingSearchbarWithBedrooms : false,
                                    searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                                    searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                                    searchbarRadius: app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null,
                                    searchbarShadow: app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null,
                                    isHomePage: false,
                                    updateUri: updateUri,
                                    builderRadius: builder.builder_properties_radius || 8,
                                    homepageLayout: true
                                }, "BookingSearchBar-contained")
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                        })
                    ]
                })
            }),
            !isDesktop && showBookingBar && app.enableBooking && app.bookingSearchbarWidth === null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlexibleSearchBar, {
                    isManager: true,
                    showOnMobile: true,
                    textColor: app.searchbarThemeColor != null && !app.searchbarThemeColor ? "text-white" : "text-black",
                    borderColor: app.searchbarThemeColor != null && !app.searchbarThemeColor ? "b-transparent-white" : "b-transparent-black",
                    designMode: app.designMode,
                    searchbarBgColor: app.searchbarBgColor != null && app.searchbarBgColor != "" ? app.searchbarBgColor : null,
                    searchbarThemeColor: app.searchbarThemeColor != null ? app.searchbarThemeColor : null,
                    containerClass: "w-100 p-0",
                    searchbarRadius: 0,
                    searchbarShadow: 0,
                    flat: true,
                    // disableInternalSticky={true}
                    calendar: calendar,
                    updateUri: updateUri
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "Properties-Index__properties bg-master-lightest",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: containerClass,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row w-100 m-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                ref: propertiesRef,
                                id: "properties",
                                className: "col-sm-12 col-lg-12 p-0",
                                style: {
                                    maxWidth: showMap && !useSwipper ? builderMapWidth + "%" : "initial"
                                },
                                children: [
                                    showFiltersBar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            id: "filters",
                                            className: "".concat(filtersDivClass, " row justify-content-center"),
                                            style: {
                                                top: app.bookingSearchbarWidth === null ? !isDesktop ? 0 : 83 : actualSearchBarHeight,
                                                zIndex: "999 !important"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: propertiesViewType == "207" ? "col-12 col-sm-12 col-md-10" : "col-12",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "row justify-content-between align-items-center",
                                                    children: showTotalPropertiesCount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            !loadingProperties ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                parentClassName: "col-auto",
                                                                skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    variant: "rectangular",
                                                                    height: 25,
                                                                    width: 140,
                                                                    className: "b-rad-md"
                                                                }),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "col-auto",
                                                                    children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidPositiveNumber */ .Z.isValidPositiveNumber(propertiesData["properties_available"]) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "fw-bold text-uppercase letter-sp-normal",
                                                                        children: t.plural("properties.count", propertiesData["properties_available"])
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                variant: "rectangular",
                                                                height: 25,
                                                                width: 140,
                                                                className: "b-rad-md"
                                                            }),
                                                            !loadingProperties ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                parentClassName: "col-auto",
                                                                skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    variant: "rectangular",
                                                                    height: 42,
                                                                    width: 107,
                                                                    className: "b-rad-md"
                                                                }),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "col-auto",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_Filters__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                        propertiesFilters: props.propertiesFilters
                                                                    })
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                variant: "rectangular",
                                                                height: 42,
                                                                width: 107,
                                                                className: "b-rad-md"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                })
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                    loadingProperties || _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(properties) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "Properties row ".concat(propertiesViewType == "207" ? "justify-content-center" : "", " w-100 m-0 ") + propertiesContainerExtraClass,
                                        children: [
                                            useSwipper ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_partials_SwipperWrapper__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    imageSlider: false,
                                                    htmlSlides: propertiesComponent,
                                                    paginationBulletsEnabled: false,
                                                    slidesPerView: slidesPerViewDesktop,
                                                    slidesPerViewLg: 3,
                                                    slidesPerViewMd: 3,
                                                    slidesPerViewSm: 2,
                                                    slidesPerViewXs: 1.4,
                                                    spaceBetween: 10,
                                                    enableLoop: false,
                                                    galleryHeight: "auto",
                                                    wrapperClassName: "d-navigation ",
                                                    enableFancyBox: false,
                                                    centeredSlides: false
                                                }, "properties-swiper")
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: !loadingProperties && properties.map(function(property, key) {
                                                    return renderProperty(property, key);
                                                })
                                            }),
                                            loadingProperties && skeletonProperties.map(function(elements) {
                                                return elements;
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_headers_NoticeHeader__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        title: t("properties.noneAvailable"),
                                        subtitle: t("properties.changeCriteria")
                                    }),
                                    !isRelatedSection && propertiesCounter > pageLimit && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_7__/* ["default"].isValidArray */ .Z.isValidArray(properties) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "Properties-Index__Paging row w-100 m-0 py-5 justify-content-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-auto",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                spacing: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    page: pageNumber,
                                                    count: paginationCounter,
                                                    onChange: function(event, page) {
                                                        pageNumberHandler(page);
                                                    },
                                                    getItemAriaLabel: function(button, number) {
                                                        switch(button){
                                                            case "page":
                                                                return "".concat(number);
                                                            case "previous":
                                                                return "previous";
                                                            case "next":
                                                                return "next";
                                                        }
                                                    }
                                                })
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                ]
                            }),
                            showMap && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: mapRef,
                                id: "map",
                                className: "sticky-top p-0 hidden-xs hidden-sm hidden-md ",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GoogleMapContent, {
                                    app: app,
                                    designMode: props.designMode,
                                    propertiesPois: properties,
                                    showMarkerCluster: false,
                                    center: relocatedCenter,
                                    googleMapApiKey: props.googleMapApiKey,
                                    inViewport: true,
                                    secondState: secondState,
                                    pixelOffsetX: pixelOffsetX,
                                    pixelOffsetY: pixelOffsetY,
                                    changeMarkerOnClick: changeMarkerOnClick,
                                    infoWindowState: infoWindowState,
                                    setInfoWindowState: setInfoWindowState,
                                    updateInfoWindowState: updateInfoWindowState,
                                    openInfoWindow: openInfoWindow,
                                    mouseMapClick: mouseMapClick,
                                    setMouseMapClick: setMouseMapClick,
                                    enableMapClustering: enableMapClustering,
                                    randomizePin: randomizePin
                                })
                            })
                        ]
                    })
                })
            }),
            showBookingBar && app.enableBooking && isListingPage && isMobile && searchBarInDrawer && app.bookingSearchbarWidth !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_property_content_columned_right_SwipeableDrawerFilters__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    calendar: calendar
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}


/***/ }),

/***/ 7828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Filters; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/i18n.ts + 7 modules
var i18n = __webpack_require__(72462);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(73582);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./redux/actions.js
var actions = __webpack_require__(23077);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 50 modules
var Modal = __webpack_require__(32293);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CloseButton.js
var CloseButton = __webpack_require__(41485);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-select/async/dist/react-select.esm.js
var react_select_esm = __webpack_require__(38109);
;// CONCATENATED MODULE: ./components/ui/inputs/AsyncSelectWrapper.tsx




// import { CloseButton, Modal } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';


// import cloneDeep from 'lodash/cloneDeep'
// import { useRouter } from 'next/router';
//
// import * as appContext from '../../../../components/AppContext';
// import Checkers from '../../../../helpers/class/Checkers';
// import { addTheme, fetchPropertiesAction, removeTheme, setOffset } from '../../../../redux/actions';
var AsyncSelectWrapper = function(props) {
    var t = (0,i18n/* useT */.NT)();
    var appSettings = (0,es/* useSelector */.v9)(function(state) {
        return state[props.reducerKey];
    });
    var identifierValues = (0,es/* useSelector */.v9)(function(state) {
        return state[props.reducerKey][props.id];
    });
    var values = props.values;
    var ref = (0,react.useState)(null), selectedSearchLocation = ref[0], setSelectedSearchLocation = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var defaultOptionsHandler = function(options) {
        var fixed_options = [];
        options.length > 0 && options.forEach(function(option) {
            var isDisabled = option.properties_count > 0 ? 0 : 1;
            fixed_options.push({
                label: option.title + " (" + option.properties_count + ")",
                value: option.id,
                isDisabled: isDisabled
            });
        });
        return fixed_options;
    };
    var loadSearchOptions = function(inputValue, callback) {
        var options = [];
        var data = values;
        data = data.filter(function(i) {
            return i.title.toLowerCase().includes(inputValue.toLowerCase());
        });
        data.forEach(function(option) {
            var isDisabled = option.properties_count > 0 ? 0 : 1;
            options.push({
                label: option.title + " (" + option.properties_count + ")",
                value: option.id,
                isDisabled: isDisabled
            });
        });
        setTimeout(function() {
            callback(options);
        }, 500);
    };
    var updateSelectedValues = function() {
        var selected_values = [];
        values.forEach(function(option) {
            if (identifierValues.includes(option.id)) {
                var isDisabled = option.properties_count > 0 ? 0 : 1;
                selected_values.push({
                    label: option.title + " (" + option.properties_count + ")",
                    value: option.id,
                    isDisabled: isDisabled
                });
            }
        });
        return selected_values;
    };
    var ref1 = (0,react.useState)(updateSelectedValues()), selectedValues = ref1[0], setSelectedValues = ref1[1];
    var handleInputChange = function(input) {
        // console.log( input )
        var selected_values = [];
        input.forEach(function(val) {
            selected_values.push(val.value);
            if (props.id == "themes") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addTheme */.__)(val.value));
                }
            }
            if (props.id == "tags") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addTag */._U)(val.value));
                }
            }
            if (props.id == "destinations") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addDestination */.HK)(val.value));
                }
            }
            if (props.id == "locations") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addLocation */.Dx)(val.value));
                }
            }
            if (props.id == "collections") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addCollection */.Hc)(val.value));
                }
            }
            if (props.id == "gtypes") {
                if (!identifierValues.includes(props.id)) {
                    dispatch((0,actions/* addType */.$u)(val.value));
                }
            }
        });
        identifierValues.forEach(function(val) {
            if (props.id == "themes") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeTheme */.w3)(val));
                }
            }
            if (props.id == "tags") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeTag */.tc)(val));
                }
            }
            if (props.id == "destinations") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeDestination */.qH)(val));
                }
            }
            if (props.id == "locations") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeLocation */.Mv)(val));
                }
            }
            if (props.id == "collections") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeCollection */.C5)(val));
                }
            }
            if (props.id == "gtypes") {
                if (!selected_values.includes(val)) {
                    dispatch((0,actions/* removeType */.Sp)(val));
                }
            }
        });
    };
    (0,react.useEffect)(function() {
        setSelectedValues(updateSelectedValues());
    }, [
        identifierValues,
        setSelectedValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
        noOptionsMessage: function() {
            return t("common.nothingFound");
        },
        loadingMessage: function() {
            return t("common.searching");
        },
        cacheOptions: false,
        defaultOptions: defaultOptionsHandler(values),
        loadOptions: loadSearchOptions,
        onChange: handleInputChange,
        className: "SearchBar-Form__form-group-select",
        isSearchable: true,
        value: selectedValues,
        placeholder: t("common.selectA", {
            title: props.title
        }),
        blurInputOnSelect: true,
        menuPlacement: "bottom",
        isMulti: true,
        components: {
            DropdownIndicator: function() {
                return null;
            },
            IndicatorSeparator: function() {
                return null;
            }
        }
    });
};
/* harmony default export */ var inputs_AsyncSelectWrapper = (/*#__PURE__*/(0,react.memo)(AsyncSelectWrapper));

// EXTERNAL MODULE: ./helpers/MethodHelper.ts
var MethodHelper = __webpack_require__(28695);
;// CONCATENATED MODULE: ./components/templates/properties/partials/FiltersModal.tsx









var FiltersModal = function(param) {
    var filters = param.filters, modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, show = param.show, Title = param.Title;
    var t = (0,i18n/* useT */.NT)();
    var ref = (0,react.useState)(show || false), showSimpleModal = ref[0], setShowSimpleModal = ref[1];
    var router = (0,next_router.useRouter)();
    var hasHash = router.asPath.includes("#");
    var uiSearchBarDivHeight = (0,es/* useSelector */.v9)(function(state) {
        return state["uiData"]["searchBarDivHeight"];
    });
    var openHandler = function() {
        setShowSimpleModal(true);
    };
    var closeHandler = function() {
        closeModal();
        setShowSimpleModal(false);
    };
    var clickOutSideHandler = function() {
        closeModal();
        setShowSimpleModal(false);
    };
    (0,react.useEffect)(function() {
        if (show) openHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        show
    ]);
    (0,react.useEffect)(function() {
        if (!hasHash && showSimpleModal) clickOutSideHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasHash
    ]);
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var applyFilters = function() {
        dispatch((0,actions/* setOffset */.nb)(0));
        dispatch((0,actions/* setPageNumber */.oW)(1));
        dispatch((0,actions/* fetchPropertiesAction */.SH)(propertiesParams, 0, uiSearchBarDivHeight));
        var cleanPath = router.asPath.split("?")[0];
        router.push({
            pathname: cleanPath,
            query: (0,MethodHelper/* cleanQuery */.M)(propertiesParams)
        }, undefined, {
            shallow: true,
            scroll: false
        });
        closeHandler();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        id: modalName,
        className: className,
        size: modalSize,
        show: showSimpleModal,
        onHide: closeHandler,
        animation: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Header */.Z.Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                        onClick: closeHandler
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "m-auto",
                        children: Title
                    })
                ]
            }, 10001),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-body",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row w-100 p-t-20 no-margin text-left",
                            children: filters != undefined && filters.map(function(filter, index) {
                                return filter.values.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter m-b-30",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12 m-b-10 title",
                                                children: filter.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_AsyncSelectWrapper, {
                                                id: filter.id,
                                                count: filter.count,
                                                title: filter.title,
                                                values: filter.values,
                                                reducerKey: "propertiesParams"
                                            })
                                        ]
                                    }, index)
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-label": "",
                                        onClick: applyFilters,
                                        className: "btn-design-color btn btn-primary w-100",
                                        children: t("properties.applyFilters")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }, 1000);
};
/* harmony default export */ var partials_FiltersModal = (/*#__PURE__*/(0,react.memo)(FiltersModal));

;// CONCATENATED MODULE: ./components/templates/properties/partials/Filters.tsx








function Filters(param) {
    var propertiesFilters = param.propertiesFilters;
    var t = (0,i18n/* useT */.NT)();
    var propertiesParams = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesParams"];
    });
    var propertiesFiltersData = (0,es/* useSelector */.v9)(function(state) {
        return state["propertiesFiltersData"];
    });
    var getFiltersArr = function(data) {
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.filters)) return data.filters;
        return (propertiesFilters === null || propertiesFilters === void 0 ? void 0 : propertiesFilters.filters) || [];
    };
    var ref = (0,react.useState)(getFiltersArr(propertiesFiltersData)), filters = ref[0], setFilters = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,actions/* countPropertiesForFiltersAction */.rr)(propertiesParams, propertiesParams, propertiesFiltersData));
    }, [
        propertiesParams
    ]);
    (0,react.useEffect)(function() {
        setFilters(getFiltersArr(propertiesFiltersData));
    }, [
        propertiesFiltersData
    ]);
    var showFilters = false;
    filters != undefined && filters.length > 0 && filters.map(function(filter) {
        if (filter.values.length > 0) {
            showFilters = true;
        }
    });
    var ref1 = (0,react.useState)("close"), modalState = ref1[0], setModalState = ref1[1];
    var handleShow = function(state) {
        setModalState(state);
    };
    var handleHide = function() {
        setModalState("close");
    };
    return showFilters ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "Properties-Index__properties-filters-button btn bg-transparent text-bg-light border-radius-10",
                onClick: function() {
                    return handleShow("modalFilters");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        className: "me-2",
                        icon: pro_solid_svg_icons/* faBarsFilter */.fqi
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "fw-normal",
                        children: t("properties.filters")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FiltersModal, {
                filters: filters,
                modalName: "filterProperties",
                className: "slide_right",
                Title: t("properties.filters"),
                modalSize: "lg",
                closeModal: function() {
                    handleHide();
                },
                show: modalState === "modalFilters"
            }, 100)
        ]
    }) : null;
}


/***/ }),

/***/ 38070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72462);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73582);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);





var NoticeHeader = function(param) {
    var title = param.title, subtitle = param.subtitle;
    var t = (0,_helpers_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useT */ .NT)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "no-result p-l-15 p-r-15 p-t-15 p-b-15 text-master text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faExclamationTriangle */ .eHv,
                    className: "m-r-5 fa-4x hint-text"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-master",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-master fs-16",
                    children: subtitle !== null && subtitle !== void 0 ? subtitle : t("booking.selectDifferentDates")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(NoticeHeader));


/***/ })

}]);